import React from 'react';
import { useNavigate } from 'react-router-dom';

import Hero from '../components/ui/Hero';

const Failed: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Hero
        title='ГРЕШКА'
        subtitle='ПОРЪЧКАТА НЕ Е УСПЕШНА'
        text='Вашата поръчка не бе приета успешно. Моля опитайте отново.'
        fontSize={42}
        buttonText='Върни се на началната страница'
        onButtonClick={() => navigate('/')}
      />
    </>
  );
};
export default Failed;
